import Request from '@request/Request';
import Auth from '@services/Utilities/Auth';

export default class extends Request {
  async submit() {
    this.beforeSubmit();
    try {
      let auth = new Auth();
      let response = await auth.requestResetPassword(this.data());
      if (response) {
        $showSuccess(response.message, 'forgot-password');
        $router.push({
          name: 'reset_password',
          query: {
            email: this.data().email,
          },
        });
      }
    } catch (error) {
      this.handleError(error);
      throw error;
    } finally {
      this.afterSubmit();
    }
  }
}
